var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recap-page" },
    [
      _c("h1", { staticClass: "recap-page__title" }, [
        _vm._v(_vm._s(_vm.$t.__("recap.title")))
      ]),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "recap-page__leave-button",
        attrs: {
          label: _vm.$t.__("common.actions.leave"),
          type: "tertiary-contrast",
          leftIcon: "close"
        },
        on: { click: _vm.handleLeave }
      }),
      _vm._v(" "),
      _c("RecapSlider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }